import React, { useEffect, useState } from 'react';
import { Container, Nav, Navbar, Offcanvas, Accordion, Row, Col, Dropdown, Form, Button, Modal } from 'react-bootstrap';
import { NavLink, Link, useNavigate, useLocation } from 'react-router-dom';
import { TbMenu2 } from 'react-icons/tb';
import Logo from '../../Assets/images/logo.png'
import Top_header from './Top_header';
import { useDispatch, useSelector } from 'react-redux';
import { showwishlist } from '../../Reducer/wishlistReducer';
import { showcartlist } from '../../Reducer/cartReducer';
import Wishlist from '../pages/Shoping/Wishlist';
import Cart from '../pages/Shoping/Cart';
import Pin from '../../Assets/images/DropDowns_MobileMenu_June7-02.png';
import Calender from '../../Assets/images/DropDowns_MobileMenu_June7-03.png';
import Contact from '../../Assets/images/DropDowns_MobileMenu_June7-04.png';
import { img_url, logout } from '../../Helper/request';
import { showaccount } from '../../Reducer/homeReducer';
import LoginAction from '../pages/LoginAction';
import { addfilter } from '../../Reducer/productReducer';
import { Helmet } from "react-helmet";
import QuickSearchmain from './QuickSearchmain';


const Header = () => {
  const isLogin = useSelector(state => state?.persistedReducer?.home?.isLogin)
  const location = useLocation()
  const [isSearchbox, isSetsearchbox] = useState(false);
  const [isActive, setActive] = useState(false);
  const [makeSticky, setmakeSticky] = useState("");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [search, setSearch] = useState("");


  useEffect(() => {
    // window.woopra.config({
    //   domain: "wd.demobw.com",
    //   outgoing_tracking: true,
    //   download_tracking: true,
    //   click_tracking: true
    // });  

    // window.woopra.identify({
    //   search: search
    // });

    // window.woopra.track();

    window.addEventListener('scroll', isSticky);
    return () => {
      window.removeEventListener('scroll', isSticky);
    };



  });


  const isSticky = (e) => {
    const header = document.querySelector('.header');

    const scrollTop = window.scrollY;
    if (scrollTop >= 100) {
      header.classList.add('is-sticky');
      setmakeSticky("mobSticky");
      setActive(true);
    } else {
      setmakeSticky("");
      header.classList.remove('is-sticky'); setActive(false);
    }
  };

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const menudata = useSelector(state => state.persistedReducer.home.menu);


  const metadetails = useSelector(state => state.persistedReducer.meta.meta);
  const home = useSelector(state => state.persistedReducer.home);
  const wishlist = useSelector(state => state.persistedReducer.wish);
  const cart = useSelector(state => state.persistedReducer.cart);
  const addedFilter = useSelector(state => state.persistedReducer.product.addedfilter);

  const [isSubmenu, setisSubmenu] = useState(true);

  const clearAllFilter = (val) => {
    if (val === "Shop All" || val === "Other") {
      const clearAllBtn = document.getElementById('clearFilter');
      if (clearAllBtn !== null) {
        clearAllBtn.click();
      }
    }

  }
  // useEffect(() => {
  //   kleviyoTracking()

  // }, [])

  const [screenWidth, setScreenWidth] = useState(window.screen.width);
  const resizeScreen = () => {
    setScreenWidth(window.innerWidth);
  };
  useEffect(() => {
    resizeScreen();
    window.addEventListener("resize", resizeScreen);
    return () => {
      window.removeEventListener("resize", resizeScreen);
    };
  }, []);

  function kleviyoTracking(params) {


    //Track events for an identified user
    window.klaviyo.push(['track', 'Elected President', {
      'Country': 'United States'
    }]);

    window.klaviyo.push(['identify', {
      // Change the line below to dynamically print the user's email.
      'email': 'matt.kemp@klaviyo-demo.com'
    }]);
    var item = {
      "ProductName": "demo track om",
      "ProductID": "op123",
      "SKU": "9999999",
      "Categories": "klaviyo rings gtracking",
      "ImageURL": "test.jpg",
      "URL": "999",
      "Brand": "999",
      "Price": "5555",
      "CompareAtPrice": "5555",
    };
    window.klaviyo.push(["track", "Viewed Product", item]);

  }
  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{metadetails?.meta_title}</title>
        {
           (!location.pathname.includes("/product-detail") && !location.pathname.includes("/custom-product-detail")) && (
            <script  type="application/ld+json">
              {`
      {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        "itemListElement": [
          {
            "@type": "ListItem",
            "position": 1,
            "name": "Home",
            "item": "${img_url}"
          }
          ${location.pathname !== "/" && metadetails?.meta_title
                  ? `,
          {
            "@type": "ListItem",
            "position": 2,
            "name": "${metadetails.meta_title}"
          }`
                  : ""
                }
        ]
      }
      `}
            </script>
          )
        }


      </Helmet>
      <Top_header width={screenWidth} />
      {/* desktop navigation */}
      <Navbar expand="lg" className='header mobile_hide'>
        <Container fluid>
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className='m-auto'>
              <NavLink className='d-none fixed-logo nav-link' to="/"><img src={Logo} alt='WDD' /></NavLink>
              {menudata?.map((val, i) =>
                <div key={i} className={val.slug == '#' ? 'nav-link notacative mainNavOptionBox' : 'nav-link mainNavOptionBox'} onClick={() => clearAllFilter(val.slug)}>
                  <NavLink className={`mainNavOption d-flex align-items-center ${val?.img_url ? "hasIcon" : ""}`} onMouseEnter={() => setisSubmenu(true)} to={val.slug} target={val.is_external_url ? "_blank" : ""}>{
                    (val?.img_url && val.slug !== "#") && <img src={val?.img_url} className='parentMenuIcon img-fluid' alt="" />
                  } {val.name}</NavLink>
                  {val?.submenu?.length ?
                    <div className={isSubmenu ? (val.name).replace(/\s/g, "_") + "_dropdown_box main_dropdown_box wedding-ring" : (val.name).replace(/\s/g, "_") + "_dropdown_box main_dropdown_box wedding-ring hide"}>
                      <Container fluid>
                        <div className="main_dropdown_innerbox_row">
                          {val?.submenu?.map((val0, index) => (
                            <div key={index} className={(val?.name).replace(/\s/g, "-") + "-" + (val0?.submenu[0]?.name)?.replace(/\s/g, "-") + " main_dropdown_innerbox_col"}>
                              {val0?.submenu?.map((val1, i) =>
                                val1?.design == "1" ?
                                  <React.Fragment key={i}>
                                    <h4><Link to={val1.slug} target={val1.is_external_url ? "_blank" : ""}>{val1.name}</Link></h4>
                                    <div className="main_dropdown_innerbox_col_2row">
                                      <ul>
                                        {val1?.submenu?.map((val2) => (
                                          <li onClick={() => clearAllFilter(val2.name)}>
                                            <Link onClick={() => setisSubmenu(false)} to={val2?.slug} target={val2.is_external_url ? "_blank" : ""}> {val2?.img_url == "" ? "" : <img src={val2?.img_url} alt={val2?.alt_tag} />} <span onClick={() => setisSubmenu(false)}>{val2.name} </span></Link></li>

                                        ))}
                                      </ul>
                                    </div>
                                  </React.Fragment>
                                  :
                                  <div className="main_dropdown_innerbox_col img-box">
                                    <Link to={val1?.slug} target={val1.is_external_url ? "_blank" : ""}>
                                      <img className='' src={val1?.img_url} alt={val1?.alt_tag} />
                                    </Link>
                                  </div>
                              )}
                            </div>
                          ))}
                        </div>
                      </Container>

                    </div> : ""}
                </div>

              )}
            </Nav>
          </Navbar.Collapse>
          <div className='top_icon_box text-end d-none'>
            <ul>
              <li className=" position-relative">
                <QuickSearchmain
                  enablePersonalisation
                  currentUrl={location.pathname}
                  onProductClick={(p) => {
                    navigate("/product-detail/" + p?.itemGroupId + "/" + p?.slug)
                  }}
                />
              </li>
              <li className=''>
                {/* Login */}
                <div className='Login_dropdown_form'>
                  <span className="header-icon account" id='login_userID' onClick={() => { dispatch(showaccount(!home?.showaccount)); dispatch(showwishlist(false)); dispatch(showcartlist(false)); setActive(true); }}></span>
                </div>
              </li>
              <li className=''>
                <div className='cart_dropdown_top wishlist_dropdown_top'>
                  <div onClick={() => { dispatch(showwishlist(!wishlist?.show)); dispatch(showcartlist(false)); dispatch(showaccount(false)); setActive(true); }}>
                    <span className="header-icon wishlist" ></span>{wishlist?.wishlistlength ? <span className='wish_item_count'>{wishlist?.wishlistlength}</span> : ""}
                  </div>
                </div>
              </li>
              <li>
                <div className='cart_dropdown_top'>
                  <div variant="success1" onClick={() => { dispatch(showcartlist(!cart?.show)); dispatch(showwishlist(false)); dispatch(showaccount(false)); setActive(true); }} >
                    <span className="header-icon cart"></span>{cart?.cartlengthvalue ? <span className='cart_item_count'>{cart?.cartlengthvalue}</span> : <span className="cart_item_count">
                      0
                    </span>}
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </Container>
      </Navbar>

      {/* mobile navigation */}
      <Container className={`${makeSticky} mobile-navigation desktop_hide`} >
        <Row>
          <Col xs={3}>
            <Link to="#" className='mobile_toggal_menu desktop_hide' onClick={handleShow}><TbMenu2 /></Link>
            <Offcanvas className='mobile_main_navigation_bar' show={show} onHide={handleClose}>
              <Offcanvas.Header closeButton>
                <Offcanvas.Title></Offcanvas.Title>
              </Offcanvas.Header>
              <Offcanvas.Body>
                <Accordion>
                  {/* {menudata?.map((val, ind) =>
                    val?.submenu?.length ?
                      <Accordion.Item eventKey={ind}>
                        <Accordion.Header><Link to={val.slug} className='mobile_main_menu_link' onClick={handleClose}>{val.name}</Link></Accordion.Header>
                        <Accordion.Body>
                          <ul className='mobile_sub_menu_box'>
                            {val?.submenu?.map(val1 =>
                              <li><Link to={val1.slug} onClick={handleClose} className='mobile_sub_menu_link'>{val1.name}</Link></li>
                            )}
                          </ul>
                        </Accordion.Body>
                      </Accordion.Item>
                      :
                      <Link to={val.slug} onClick={handleClose} className='mobile_main_menu_link'>{val.name}</Link>
                  )} */}

                  {menudata?.map((val, ind) =>
                    val?.submenu?.length ?
                      <Accordion.Item key={ind} eventKey={ind} className={(val.name).replace(/\s/g, "-")}>
                        <Accordion.Header><Link to={val.slug} target={val.is_external_url ? "_blank" : ""} className='mobile_main_menu_link d-flex align-items-center' onClick={handleClose}>
                          {
                            (val?.img_url && val.slug !== "#") && <img src={val?.img_url} className='parentMenuIcon img-fluid' alt="" />
                          }
                          {val.name}


                        </Link>
                        </Accordion.Header>
                        <Accordion.Body>
                          {val?.submenu?.map((val1, index) =>
                            val1?.submenu?.map((val2, i) =>
                              <div key={i} className={val2?.name + ' menu-list'}>
                                {val2?.img_url?.length ? 
                                (val2?.name!=="Banner" &&  <h2 className='withImg'><Link to={val2?.slug} onClick={handleClose} target={val2.is_external_url ? "_blank" : ""}>
                                <img src={val2?.img_url} alt='' /> {val2?.name}</Link></h2> )
                               
                                : <h2> <Link onClick={handleClose} to={val2?.slug} target={val2.is_external_url ? "_blank" : ""}>{val2?.name}</Link></h2>}
                                <div className={val2?.design == 3 ? 'menu-items column-3' : val2?.design == 2 ? 'menu-items column-2' : 'single-list withImg px-4'}>
                                  {val2?.submenu?.map((val3, i) =>
                                    <Link key={i} to={val3.slug} onClick={handleClose}>
                                      {val3?.img_url?.length ? <img src={val3?.img_url} alt={val3?.alt_tag} /> : ""}
                                      <span onClick={() => clearAllFilter(val3?.name)}>{val3?.name}</span>
                                    </Link>
                                  )}
                                </div>
                              </div>
                            )
                          )}
                        </Accordion.Body>
                      </Accordion.Item> :
                      <Link to={val.slug} target={val.is_external_url ? "_blank" : ""} onClick={handleClose} className='mobile_main_menu_link d-flex align-items-center'>
                        {
                          (val?.img_url && val.slug !== "#") && <img src={val?.img_url} className='parentMenuIcon img-fluid' alt="" />
                        }
                        {val.name}</Link>
                  )}

                  <div className='info' onClick={handleClose}>
                    <Link to={'/showroom'} className='mobile_main_menu_link'><span><img src={Contact} alt='' /></span> Find a Showroom</Link>
                    <Link to={'/book-an-appointment'} className='mobile_main_menu_link'><span><img src={Calender} alt='' /></span> Book an Appointment</Link>
                    <Link to={'/contact-us'} className='mobile_main_menu_link'><span><img src={Pin} alt='' /></span> Contact us</Link>
                    <Link to={"/sell-gold-silver-jewelry"} className="mobile_main_menu_link">

                      Sell Gold & Silver
                    </Link>

                    {
                      isLogin ? <Link to={"/settings"} className="mobile_main_menu_link mt-5">
                        <span className="header-icon account"></span> My Account
                      </Link> : <Link to={"/login"} className="mobile_main_menu_link mt-5">
                        <span className="header-icon account"></span> Sign In
                      </Link>
                    }
                    <Link to={'/wishlist'} className='mobile_main_menu_link'><span className="header-icon wishlist"></span> Wish List</Link>
                  </div>
                </Accordion>
              </Offcanvas.Body>
            </Offcanvas>
          </Col>
          <Col xs={6}>
            <div className='brand-name1 text-center'>
              <Link to="/">
                <img src={Logo} alt='Wedding Days Diamond' className='img-fluid' />
              </Link>
            </div>
          </Col>
          <Col xs={3}>
            <div className='top_icon_box text-end'>
              <ul className='d-flex justify-content-end align-items-center'>
                <li className='mobile-search-box'>
                  <QuickSearchmain isSetsearchbox={isSetsearchbox} />
                  {/* <span className={isSearchbox ? "closebtn open" : "closebtn close"} onClick={() => isSetsearchbox(!isSearchbox)}>x</span> */}
                  {/* <div className='search_box_menu'><span className="header-icon search" onClick={() => isSetsearchbox(!isSearchbox)}></span></div> */}
                </li>
                <li><Link to="/cart"><span className="header-icon cart"></span>{cart?.cartlengthvalue ? <span className='wish_item_count'>{cart?.cartlengthvalue}</span> : ""}</Link></li>
              </ul>
            </div>
          </Col>
        </Row>
      </Container>
      {/* <Modal show={wishlist?.show} onHide={() => dispatch(showwishlist(!wishlist?.show))}><div className='wishlist_dropdown wishlist_dropdown_top cart_dropdown_top'><Wishlist popup={true} /></div></Modal>
      <Modal show={cart?.show} onHide={() => dispatch(showcartlist(!cart?.show))}><div className='wishlist_dropdown wishlist_dropdown_top cart_dropdown_top'><Cart popup={true} /></div> </Modal> */}

      <Modal className={isActive ? "active-fix wishlist-modal-top" : 'wishlist-modal-top'} backdropClassName='wishlist-backdrop' show={wishlist?.show} onHide={() => { dispatch(showwishlist(!wishlist?.show)); setActive(false); }}><div className='wishlist_dropdown wishlist_dropdown_top cart_dropdown_top'><Wishlist popup={true} /></div></Modal>

      <Modal className={isActive ? "active-fix wishlist-modal-top" : 'wishlist-modal-top'} backdropClassName='wishlist-backdrop' show={cart?.show} onHide={() => { dispatch(showcartlist(!cart?.show)); setActive(false); }}><div className='wishlist_dropdown wishlist_dropdown_top cart_dropdown_top'><Cart popup={true} /></div> </Modal>


      {/* Login Modal */}
      <Modal className={isActive ? "active-fix wishlist-modal-top" : 'wishlist-modal-top'} backdropClassName='wishlist-backdrop' show={home?.showaccount} onHide={() => { dispatch(showaccount(!home?.showaccount)); setActive(false); }}>
        <div className='Login_dropdown_form'>
          <div className='dropdown_menu_box'>
            {home?.isLogin ?
              <div className="">
                <h1 className="title">Hi, {home?.user.first_name + " " + home?.user.last_name}</h1>
                <h4 className="sub-title">My Account </h4>
                <ul>
                  <li>
                    <Link onClick={() => { dispatch(showaccount(!home?.showaccount)); setActive(false); }} to="/settings">Account Dashboard</Link>
                  </li>
                  <li>
                    <Link onClick={() => { dispatch(showaccount(!home?.showaccount)); setActive(false); }} to="/cart">Shopping Cart</Link>
                  </li>
                  <li>
                    <Link onClick={() => { dispatch(showaccount(!home?.showaccount)); setActive(false); }} to="/order-history">Order History</Link>
                  </li>
                  <li>
                    <Link onClick={() => { dispatch(showaccount(!home?.showaccount)); setActive(false); }} to="/wishlists">Wish List</Link>
                  </li>
                </ul>
                <Button onClick={() => logout()} className='theme_btn login_btn'>
                  Sign Out
                </Button>
              </div>
              :
              <>
                <LoginAction />
                <p>Don't have an account? <br /> Create One !</p>
                <Link className='theme_btn login_btn' to='/login' onClick={() => dispatch(showaccount(false))}>Create Account</Link>
              </>
            }
          </div>
        </div>
      </Modal>
    </>
  )
}

export default Header;